<template>
	<div ref="switchProfile">
		<div class="position-relative mt-1">
			<img
				class="apply-image-position"
				src="../../assets/headerSearch.svg"
				alt=""
			/>
			<b-form-input
				class="resumes-search-input apply-job-modal"
				placeholder="Search Profile"
				type="search"
				clearable
				v-model="searchQuery"
			>
			</b-form-input>
		</div>
		<b-form-group v-slot="{ ariaDescribedby }" v-if="allProfileList.length > 0">
			<b-form-radio-group
				id="radio-group-2"
				v-model="selected"
				:aria-describedby="ariaDescribedby"
				name="radio-sub-component"
			>
				<b-form-radio
					v-for="(profile, i) in allProfileList"
					:key="i"
					:value="profile._id"
					><img
						v-if="profile.primary"
						height="20"
						class="mr-1"
						src="../../assets/New Profile/main-profile-icon2.svg"
						alt=""
					/>
					<img
						height="20"
						v-else
						class="mr-1"
						src="../../assets/New Profile/viewAll-resume-icon.svg"
						alt=""
					/>
					{{ profile?.profileName }}</b-form-radio
				>
			</b-form-radio-group>
		</b-form-group>
		<p
			v-if="searchQuery && allProfileList.length == 0"
			class="fs-13 fw-LM fam-lato text-italic text-888888 d-flex align-items-center justify-content-center py-5"
		>
			No results found
		</p>
	</div>
</template>

<script>
import { getAllProfiles } from "@/utils/apiFunctions";
export default {
	name: "SwitchProfile",
	data() {
		return {
			allProfileList: [],
			searchQuery: "",
			selected: null,
			localCandidateInfo: {},
			selectedProfile: {},
			selectPrimary: true,
			showDropdown: false,
		};
	},
	watch: {
		async selected() {
			this.searchQuery = "";
			this.$emit("switch-profile", this.selected);
		},
		async searchQuery() {
			// this.$emit("search-profile", this.searchQuery);
			this.searchQuery = this.searchQuery.trim();
			this.selectPrimary = false;
			await this.getAllProfiles();
		},
	},
	created() {
		this.getAllProfiles();
	},
	mounted() {
		document.addEventListener("click", this.handleClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.handleClickOutside);
	},
	methods: {
		handleClickOutside(event) {
			const profileBox = this.$refs.switchProfile;
			if (
				profileBox &&
				!profileBox.contains(event.target) &&
				event.target.classList.contains("mob-back-body")
			) {
				this.$emit("close-switch-profile");
			}
		},
		async getAllProfiles() {
			this.showProfileListLoader = true;
			try {
				const res = await getAllProfiles(this.searchQuery);
				if (res.status == 200) {
					this.allProfileList = res.data.data
						.map(
							({
								profileName,
								_id,
								draft,
								primary,
								experienceLevel,
								customFields,
								atsResume,
								graphicalResume,
							}) => ({
								profileName,
								_id,
								draft,
								primary,
								experienceLevel,
								profileCompletionPercentage:
									customFields.profileCompletionPercentage,
								atsResume,
								graphicalResume,
							})
						)
						.filter(
							({
								experienceLevel,
								profileCompletionPercentage,
								atsResume,
								graphicalResume,
							}) => {
								const completion = profileCompletionPercentage ?? 0;
								if (experienceLevel === "fresher" || experienceLevel === "student") {
									return (
										completion >= 45 ||
										Object.keys(atsResume).length > 0 ||
										Object.keys(graphicalResume).length > 0
									);
								}
								if (
									experienceLevel === "intermediate" ||
									experienceLevel === "senior"
								) {
									return (
										completion >= 70 ||
										Object.keys(atsResume).length > 0 ||
										Object.keys(graphicalResume).length > 0
									);
								}
								return false;
							}
						);

					this.allProfileListNum = this.allProfileList.length;
					if (this.selectPrimary) {
						this.selectedProfile = this.allProfileList.find(
							(obj) => obj.primary
						);
						this.selected = this.selectedProfile?._id;
						this.$emit("selected-profile", this.selectedProfile);
						this.$emit("profile-list", this.allProfileList);
					}
					this.$forceUpdate();
				} else {
					console.log("Api error");
				}
			} catch (error) {
				console.log(error);
			}
			this.showProfileListLoader = false;
		},
	},
};
</script>
<style>
.apply-job-modal.form-control {
	height: 32px;
}
.apply-image-position {
	position: absolute;
	left: 10px;
	top: 8px;
}

.switch-parent-radio .custom-control-inline {
	margin-right: 0;
}

.switch-parent-radio .custom-control {
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	min-height: 35px;
	cursor: pointer;
	padding-left: 36px;
}
@media (max-width: 1028px) {
	.switch-parent-radio .custom-control {
		border-bottom: 1px solid #d9d9d9;
		min-height: 45px;
	}
	.switch-parent-radio .form-group {
		max-height: 300px;
	}
}
.switch-parent-radio .custom-control:hover {
	background-color: #e9f0f5;
	border-radius: 5px;
}
.switch-parent-radio
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
}

.switch-parent-radio .custom-control-label::after {
	border: 2px solid #20639b;
	border-radius: 50%;
}
.switch-parent-radio
	.custom-control-input:checked
	~ .custom-control-label::before {
	color: #fff;
	border-width: 4px;
	border-color: #fff;
	background-color: #20639b;
}

.switch-parent-radio .custom-control-label::before {
	border: 2px solid #20639b;
}

.switch-parent-radio .custom-control-label {
	font-family: "Lato", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #3a3c40;
}
.switch-parent-radio .form-group {
	max-height: 200px;
	overflow: auto;
	margin-bottom: 0;
}
</style>
